import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { OptionSwatch } from '../OptionSwatch';
import { TOptionsDialogState } from '../../types/dialogs.types';

type TProps = {
  state?: TOptionsDialogState;
  setState: (state: TOptionsDialogState) => void;
};

const OptionsDialog = ({ state, setState }: TProps) => {
  return (
    <Dialog
      open={state?.isOpen || false}
      onOpenChange={(e, data) => {
        e.stopPropagation();
        if (state) setState({ ...state, isOpen: data.open });
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button appearance="subtle" aria-label="close" icon={<Dismiss24Regular />} />
              </DialogTrigger>
            }
          >
            {state?.title}
          </DialogTitle>

          <DialogContent>
            <OptionSwatch
              label={state?.label || ''}
              selectedValue={state?.selectedValue}
              setSelectedValue={state?.setSelectedValue}
              options={state?.options || []}
              modeLocked={state?.modeLocked}
              className="mb-4"
            />
            {state?.footer && <div className="mt-2">{state.footer}</div>}
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default OptionsDialog;
